// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function RetireTreeBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M16 9.5a1.5 1.5 0 0 1 1.5 1.5v18a1.5 1.5 0 0 1-3 0V11A1.5 1.5 0 0 1 16 9.5Z"
						clipRule="evenodd"
					/>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M8.658 15.33a1.5 1.5 0 0 1 2.013-.672l6 3a1.5 1.5 0 1 1-1.342 2.684l-6-3a1.5 1.5 0 0 1-.67-2.013Z"
						clipRule="evenodd"
					/>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M23.342 12.33a1.5 1.5 0 0 1-.671 2.012l-6 3a1.5 1.5 0 1 1-1.342-2.684l6-3a1.5 1.5 0 0 1 2.013.671Z"
						clipRule="evenodd"
					/>
					<path
						fill="currentColor"
						fillRule="evenodd"
						d="M16 1.5a10.004 10.004 0 0 0-9.148 5.953A9.5 9.5 0 1 0 16 24.077 9.5 9.5 0 0 0 28.096 9.684a9.5 9.5 0 0 0-2.95-2.23A10.004 10.004 0 0 0 16 1.5Zm7.715 8.595a2.498 2.498 0 0 1-1.258-1.303h-.001a7.003 7.003 0 0 0-12.915 0h.001a2.5 2.5 0 0 1-1.258 1.303h-.002a6.5 6.5 0 1 0 6.325 11.31l-.003.003a2.504 2.504 0 0 1 2.789-.001 6.5 6.5 0 1 0 6.323-11.312h-.001Z"
						clipRule="evenodd"
					/>
				</svg>
			}
		</IconContainer>
	);
}
